<!--商家详情页-->
<template>
  <section id="merchantDetails">
    <!--轮播图展示-->
    <v-swipe v-bind:swipes="lunbos"></v-swipe>
    <!--商家信息-->
    <div class="payment">
      <img :src="initData.logo" alt>
      <h2>{{initData.name}}</h2>
      <!-- <a :href="downUrl">买单</a> -->
      <p>{{initData.summary}}</p>
    </div>
    <!--地图号码模块-->
    <v-mapInfo1 v-bind:mapinfoData="mapinfoData"></v-mapInfo1>
    <!--团购促销模块-->
    <div class="smallActivities">
      <!--团购列表-->
      <section class="Group">
        <h3 class="title">团购信息</h3>
        <div v-if="GrouponList.length>0" class="have">
          <h3>团购套餐</h3>
          <ul>
            <li v-for="(item, n) in GrouponList" :key="n">
              <a :href="downUrl">
                <div>
                  <img :src="item.picUrl" alt>
                  <div class="right">
                    <h4>{{item.name}}</h4>
                    <span>已售{{item.qtySale}}单</span>
                    <p>
                      ￥{{item.price}}
                      <s>￥{{item.priceOrigin}}</s>
                    </p>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <!--如果团购列表的长度大于3则渲染-->
          <div class="more" v-if="GrouponList.length>2">
            <a :href="downUrl">
              查看其它团购
              <span></span>
            </a>
          </div>
        </div>
        <!--如果团购列表中没有值就显示出来-->
        <div v-else class="null">暂无团购信息</div>
      </section>
      <!--优惠促销列表-->
      <section class="Promotion">
        <h3 class="title">优惠促销</h3>
        <div v-if="promotionList.length>0" class="have">
          <ul>
            <li v-for="(item, n) in promotionList" :key="n">
              <div class="left">
                <span>{{item.price | filterPrice}}</span>
                <br>
                <a href @click.prevent="getDownURL(params)" class="lingqu"></a>
              </div>
              <div class="right">
                <p
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                >{{item.name}}</p>
                <p
                  class="date"
                >有效期：{{item.limitStartTime|dateFormat('YYYY.MM.DD')}}-{{item.limitEndTime|dateFormat('YYYY.MM.DD')}}</p>
              </div>
            </li>
          </ul>
          <!--如果团购列表的长度大于2则渲染 "-->
          <div class="more" v-if="promotionList.length>2">
            <a href @click.prevent="getDownURL(params)">
              <span>查看其它优惠</span>
            </a>
          </div>
        </div>
        <!--如果团购列表中没有值就显示出来-->
        <div v-else class="null">暂无团购信息</div>
      </section>
    </div>
    <!--评论模块-->
    <v-comment v-bind:idobj="idobj" :params="params"></v-comment>
  </section>
</template>

<script>
import wxapi from "@/common/wxapi";
import tencenApi from '@/common/tencentapi';
import Logo from "../../assets/img/logo.png";
import comSwipe from "../frame/swipe.vue";
import comMapInfo1 from "../frame/mapInfo1.vue";
import comComment from "../frame/comment.vue";
import { getDownURL } from "../../common/api.config";
import {
  fetchShopData,
  fetchGoodsList,
  fetchVolumeDetail
} from "../../common/api/homePage";

export default {
  mixins: [wxapi],
  data() {
    return {
      idobj: "",
      lunbos: [],
      initData: {},
      mapinfoData: {},
      //                促销列表
      promotionList: [],
      //                团购列表
      GrouponList: [],
      obj: {
        longitude: 0,
        latitude: 0
      },
      cmd: {
        cmd: "C0070002", // 商家详情
        url: "",
        params: "",
        h5Params: "{}",
        events: []
      },
      shareConfig: {
        link: window.location.href,
        title: "",
        desc: "",
        imgUrl: "",
        from: "优托邦APP"
      }
    };
  },
  created() {
    this.getInitData();
    if (this.isweixin()) {
      this.wxRegister(this.wxRegCallback);
    }
  },
  watch: {
    obj(curVal) {
      fetchVolumeDetail(this.id, curVal).then(rep => {
        if (rep.data.code === 0) {
          let data = rep.data.data.goods;
          //                        更新距离
          this.mapinfoData.distance = data.distance;
        }
      });
    }
  },
  computed: {
    params() {
      this.cmd.params = JSON.stringify({
        shopId: this.shopId,
        mallId: this.mallId
      });
      return this.cmd;
    },
    shopId() {
      return this.$route.params.shopId;
    },
    mallId() {
      return this.$route.query.mallId;
    }
  },
  methods: {
    getDownURL,
    getLocation() {
      if (navigator.geolocation) {
        var getOptions = {
          //是否使用高精度设备，如GPS。默认是true
          enableHighAccuracy: true,
          //超时时间，单位毫秒，默认为0
          timeout: 60000,
          //使用设置时间内的缓存数据，单位毫秒
          //默认为0，即始终请求新数据
          //如设为Infinity，则始终使用缓存数据
          maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError,
          getOptions
        );
      }
    },
    showPosition(position) {
      let obj = {
        latitude: position.coords.latitude, //纬度
        longitude: position.coords.longitude //经度
      };
      this.obj = obj;
    },
    showError() {},
    filtertep(val1, val2) {
      let arr = [];
      if (val1 || val2) {
        if (val1) {
          arr[0] = {
            name: val1,
            method() {
              window.location.href = "tel:" + val1;
            }
          };
        } else {
          arr[0] = {
            name: val2,
            method() {
              window.location.href = "tel:" + val2;
            }
          };
        }
      }
      if (val2 && val1) {
        arr[1] = {
          name: val2,
          method() {
            window.location.href = "tel:" + val2;
          }
        };
      }
      return arr;
    },
    getInitData() {
      fetchShopData(this.shopId, this.mallId, this.obj).then(rep => {
        if (rep.data.code === 0) {
          let data = rep.data.data;
          this.lunbos = data.bannerPics;
          this.initData = data;
          this.idobj = {
            type: "shopId",
            id: this.shopId
          };
          this.mapinfoData = {
            title: data.name,
            map: data.address,
            address: data.floor + "楼  ",
            merchantTime: data.onlineStartTime + "-" + data.onlineEndTime,
            distance: data.meter,
            actions: this.filtertep(data.tel, data.phone),
            shopAddr: { longitude: data.longitude, latitude: data.latitude }
          };
          this.shareConfig = {
            title: data.name,
            desc: data.summary || ' ',
            imgUrl: data.logo || (window.location.origin + window.location.pathname + Logo)
          };
          if (this.isQQ()) {
            this.qqShareInfo()
          }
          if (data.shopNo) {
            this.mapinfoData.address += data.shopNo;
          }
        }
      });
      //                获取团购信息
      fetchGoodsList(this.mallId, 5, this.shopId).then(rep => {
        if (rep.data.code === 0) {
          this.GrouponList = rep.data.data.goodsPage;
        }
      });
      //                获取优惠促销信息
      fetchGoodsList(this.mallId, 2, this.shopId).then(rep => {
        if (rep.data.code === 0) {
          this.promotionList = rep.data.data.goodsPage;
        }
      });
    },
    toggleTabs: function(index) {
      this.nowIndex = index;
    },
    /**
     * [wxRegCallback 用于微信JS-SDK回调]
     **/
    wxRegCallback() {
      this.wxShareAppMessage();
      this.wxMenuShareQQ();
      this.wxShareTimeline();
    },
    /**
     * [wxShareAppMessage 微信自定义分享到朋友]
     **/
    wxShareAppMessage() {
      let opstion = {
        title: this.shareConfig.title,
        desc: this.shareConfig.desc,
        link: this.shareConfig.link,
        imgUrl: this.shareConfig.imgUrl,
        type: "link",
        dataUrl: "",
        success: function() {},
        cancel: function() {}
      };
      this.ShareAppMessage(opstion);
    },
    /**
     * [wxMenuShareQQ 自定义分享到QQ]
     **/
    wxMenuShareQQ() {
      let opstion = {
        title: this.shareConfig.title,
        desc: this.shareConfig.desc,
        link: this.shareConfig.link,
        imgUrl: this.shareConfig.imgUrl,
        success: function() {},
        cancel: function() {}
      };
      this.MenuShareQQ(opstion);
    },
    /**
     * [wxShareTimeline 微信自定义分享到朋友圈]
     **/
    wxShareTimeline() {
      let opstion = {
        title: this.shareConfig.title,
        link: this.shareConfig.link,
        imgUrl: this.shareConfig.imgUrl,
        success: function() {},
        cancel: function() {}
      };
      this.ShareTimeline(opstion);
    },
    /**
     * QQ分享
     */
    qqShareInfo() {
      let options = {
        title: this.shareConfig.title,
        summary: this.shareConfig.desc,
        pic: this.shareConfig.imgUrl,
        url: this.shareConfig.link
      }
      setShareInfo(options)
    }
  },
  // 用来定义子组件
  components: {
    "v-swipe": comSwipe,
    "v-mapInfo1": comMapInfo1,
    "v-comment": comComment
  },
  filters: {
    filterPrice(val) {
      return val > 0 ? val / 100 + "元" : "免费";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/px2rem.scss";
html,
body,
main,
.app-main {
  height: 100%;
  background-color: #f6f6f6;
}
#merchantDetails {
  /*买单部分*/
  .payment {
    margin-bottom: px2rem(12);
    padding: px2rem(24) px2rem(12);
    background-color: #fff;
    position: relative;
    img {
      position: absolute;
      width: px2rem(68);
      height: px2rem(68);
      border-radius: 50%;
      left: px2rem(12);
      top: px2rem(-44);
    }
    h2 {
      max-width: px2rem(260);
      display: inline-block;
      color: #333;
      font-size: px2rem(18);
      line-height: px2rem(25);
      padding-top: px2rem(8);
      font-weight: normal;
    }
    a {
      display: inline-block;
      height: px2rem(32);
      width: px2rem(88);
      background-image: linear-gradient(-90deg, #ff5b00 0%, #ff413e 100%);
      border-radius: px2rem(4);
      float: right;
      font-size: px2rem(16);
      line-height: px2rem(32);
      color: #fff;
      text-align: center;
    }
    p {
      margin-top: px2rem(12);
      color: #999;
      font-size: px2rem(14);
      line-height: px2rem(20);
    }
  }
  /*团购信息*/
  section.Group {
    background-color: #fff;
    margin-bottom: px2rem(14);
    .have {
      margin-top: px2rem(12);
      h3 {
        padding-left: px2rem(40);
        font-size: px2rem(16);
        color: #333333;
        font-weight: normal;
        position: relative;
        &:before {
          content: "";
          background: url(../../assets/img/food_tuan.png) center no-repeat;
          background-size: 100% 100%;
          width: px2rem(16);
          height: px2rem(16);
          position: absolute;
          bottom: px2rem(2);
          left: px2rem(12);
        }
      }
      ul {
        padding-left: px2rem(40);
        li {
          height: px2rem(92);
          padding: px2rem(12) 0;
          a {
            display: block;
            height: 100%;
            width: 100%;
            overflow: hidden;
            div {
              position: relative;
              height: 100%;
              padding-left: px2rem(80);
              img {
                position: absolute;
                left: 0;
                top: 0;
                width: px2rem(68);
                height: px2rem(68);
                border-radius: px2rem(4);
                margin-right: px2rem(12);
                background-color: #333;
              }
              div.right {
                padding: 0;
                padding-right: px2rem(32);
                color: #999;
                h4 {
                  color: #333;
                  font-size: px2rem(16);
                  line-height: px2rem(22);
                  margin-bottom: px2rem(4.5);
                }
                span {
                  float: right;
                  position: relative;
                  margin-bottom: px2rem(2.5);
                  &:before {
                    content: "";
                    position: absolute;
                    top: px2rem(-2);
                    right: px2rem(-16);
                    width: px2rem(16);
                    height: px2rem(16);
                    background: url(../../assets/img/food_rigth_cheng.png)
                      center no-repeat;
                    background-size: 100% 100%;
                  }
                }
                p {
                  clear: both;
                  font-size: px2rem(16);
                  line-height: px2rem(22);
                  color: #ff4a2a;
                  s {
                    color: #999;
                    font-size: px2rem(12);
                    line-height: px2rem(17);
                    padding-left: px2rem(8);
                  }
                }
              }
            }
          }
        }
      }
      div.more {
        height: px2rem(44);
        text-align: center;
        a {
          display: block;
          margin: 0 auto;
          height: 100%;
          width: 70%;
          font-size: px2rem(14);
          line-height: px2rem(44);
          color: #666;
          span {
            display: inline-block;
            width: px2rem(16);
            height: px2rem(16);
            background: url(../../assets/img/food_drop_nor.png) center px2rem(3)
              no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  section.Promotion {
    background-color: #fff;
    margin-bottom: px2rem(14);
    ul {
      padding: px2rem(12);
      li {
        width: px2rem(351);
        height: px2rem(104);
        margin-bottom: px2rem(12);
        background: url(../../assets/img/food_banquan_you_Merchant.png)
            no-repeat right center,
          url(../../assets/img/food_banquan_zuo_Merchant.png) no-repeat left
            center,
          url(../../assets/img/touming@2x.png) repeat-y px2rem(101) top #fff5df;
        padding: 0 px2rem(9);
        div {
          float: left;
        }
        div.left {
          width: px2rem(101);
          padding: px2rem(20) 0;
          text-align: center;
          span {
            font-size: px2rem(18);
            line-height: px2rem(18);
            color: #8b572a;
            letter-spacing: 0;
          }
          a {
            display: block;
            margin: 0 auto;
            width: px2rem(60);
            height: px2rem(28);
            margin-top: px2rem(4);
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          a.lingqu {
            background-image: url(../../assets/img/food_button_lingqu.png);
          }
          a.qianggou {
            background-image: url(../../assets/img/food_button_qianggou.png);
          }
          a.yilingqu {
            background-image: url(../../assets/img/food_button_qianggou.png);
          }
          a.yiqianggou {
            background-image: url(../../assets/img/food_button_yiqianggou.png);
          }
        }
        div.right {
          width: px2rem(224);
          padding-right: px2rem(13);
          padding-top: px2rem(29);
          p {
            text-align: center;
            font-size: px2rem(16);
            line-height: px2rem(22);
            color: #8b572a;
          }
          p.date {
            font-size: px2rem(12);
            margin-top: px2rem(8);
          }
        }
      }
    }
  }
  section {
    h3.title {
      font-size: px2rem(14);
      line-height: px2rem(44);
      color: #999;
      height: px2rem(44);
      padding-left: px2rem(12);
      border-bottom: px2rem(1) solid #eee;
    }
  }
  div.more {
    height: px2rem(44);
    text-align: center;
    a {
      display: block;
      margin: 0 auto;
      height: 100%;
      width: 70%;
      font-size: px2rem(14);
      line-height: px2rem(44);
      color: #666;
      span {
        display: inline-block;
        width: px2rem(16);
        height: px2rem(16);
        background: url(../../assets/img/food_drop_nor.png) center px2rem(3)
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .null {
    height: px2rem(92);
    line-height: px2rem(92);
    font-size: px2rem(14);
    color: #999;
    text-align: center;
  }
}
</style>
